module.exports = __webpack_public_path__ + "static/media/archive.b5332c68.svg";